import { createSlice } from '@reduxjs/toolkit'


export const currentLoged = createSlice({
  name: 'CompanyUser',
  initialState : { },
  reducers: {
    getCurrentLoged: (state, action) => {
      state.data = action.payload
    },
    UpdateUserCompany: (state, action) => {
      state = action.payload
    },
  },
})

export const { getCurrentLoged, UpdateUserCompany } = currentLoged.actions

export default currentLoged.reducer